export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  announcementManage: 'announcement-manage',
  announcementCenter: 'announcement-center',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  announcementManage: {
    view: 'view',
    query: 'query',
    search: 'search',
    filter: 'filter',
    create: 'create',
    edit: 'edit',
    submit: 'submit',
    revoke: 'revoke',
    upload: 'upload',
  },
  announcementCenter: {
    view: 'view',
    query: 'query',
    search: 'search',
  },
} as const;

export const ALL_PERMISSION_KEYS = [
  PERMISSION_RESOURCE_CODES.permission,
  PERMISSION_RESOURCE_CODES.announcementManage,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.view}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.query}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.search}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.filter}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.create}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.edit}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.submit}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.revoke}`,
  `${PERMISSION_RESOURCE_CODES.announcementManage}:${PERMISSION_ACTION_CODES.announcementManage.upload}`,
  PERMISSION_RESOURCE_CODES.announcementCenter,
  `${PERMISSION_RESOURCE_CODES.announcementCenter}:${PERMISSION_ACTION_CODES.announcementCenter.view}`,
  `${PERMISSION_RESOURCE_CODES.announcementCenter}:${PERMISSION_ACTION_CODES.announcementCenter.query}`,
  `${PERMISSION_RESOURCE_CODES.announcementCenter}:${PERMISSION_ACTION_CODES.announcementCenter.search}`,
] as const;
